var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBell16 = function SvgIconBell16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1.957 9.984c.143.106.35.204.573.326.783.405 2.232.974 4.683 1.432 3.005.56 4.709.419 5.557.258-.411-.755-.911-2.025-.638-3.49.36-1.928.216-3.57-.447-4.73-.55-1-1.472-1.652-2.639-1.869s-2.24.06-3.134.792c-1.04.863-1.763 2.324-2.122 4.251-.273 1.465-1.177 2.474-1.833 3.03ZM9.214 12.308a2 2 0 1 1-3.932-.733"
  })));
};
export default SvgIconBell16;